var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mdTabs, mdTab, mdButton, mdDialogActions, mdContent, mdIcon } from 'vue-material';
var CompProps = Vue.extend({
    props: {
        slogan: String
    }
});
var AboutMe = /** @class */ (function (_super) {
    __extends(AboutMe, _super);
    function AboutMe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.styleObject = {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            padding: '10px',
            height: '100vh',
            overflowY: 'scroll'
        };
        return _this;
    }
    AboutMe.prototype.data = function () {
        return {
            subpage: '1'
        };
    };
    AboutMe = __decorate([
        Component({
            components: {
                mdButton: mdButton,
                mdTabs: mdTabs,
                mdTab: mdTab,
                mdDialogActions: mdDialogActions,
                mdContent: mdContent,
                mdIcon: mdIcon
            }
        }),
        Component
    ], AboutMe);
    return AboutMe;
}(CompProps));
export default AboutMe;
